<pl-course-content
  *ngIf="friendsSurveyToken()"
  [pageType]="PageType.friendsSurvey"
  [tokenSurvey]="friendsSurveyToken()"
/>
